import styled from 'styled-components';
import { Button } from 'shared/components/Button';
import { Modal } from 'shared/components/Modal';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Tabs.ConsentModal';

export const ConsentModal = ({ onOkClick, onCancelClick, onClose }) => (
  <ConsentModal.Modal
    data-qa="checkout_consent_modal"
    onClose={onClose}
    title={t(`${TP}.consentModalTitle`, 'Notice of Consent')}
  >
    <ConsentModal.ModalText>
      {t(
        `${TP}.consentModalText`,
        'By proceeding, you consent to GOAT storing your CN ID number in connection with processing your order and assessing relevant taxes, if any.',
      )}
    </ConsentModal.ModalText>
    <ConsentModal.Okay inverted data-qa="checkout_consent_modal_confirm" onClick={onOkClick}>
      {t(`${TP}.modalOkButton`, 'Okay')}
    </ConsentModal.Okay>
    <ConsentModal.Cancel href="" data-qa="checkout_consent_modal_cancel" onClick={onCancelClick}>
      {t(`${TP}.modalCancelButton`, 'Cancel')}
    </ConsentModal.Cancel>
  </ConsentModal.Modal>
);

ConsentModal.Modal = styled(Modal)`
  max-width: 335px;
`;

ConsentModal.ModalText = styled.p`
  margin: 0;
  padding: 8px 0;
`;

ConsentModal.Okay = styled(Button)`
  font-size: 9.5px;
  width: 100%;
  text-transform: uppercase;
  margin-top: 32px;
`;

ConsentModal.Cancel = styled.a`
  display: block;
  text-align: center;
  margin-top: 16px;
  text-decoration: underline;
`;
